import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../context/ThemeContext";
const GamesHub = () => {
    const navigate = useNavigate();
    const { themeColors } = useContext(ThemeContext);
    const tronStyles = `
    @keyframes avaTronGlowSweep {
      0% { transform: translateX(-40%) rotate(-12deg); opacity: 0; }
      35% { opacity: 0.55; }
      70% { opacity: 0.22; }
      100% { transform: translateX(140%) rotate(-12deg); opacity: 0; }
    }

    @keyframes avaTronGridDrift {
      0% { background-position: 0 0, 0 0; }
      100% { background-position: 0 140px, 140px 0; }
    }

    @keyframes avaTronPulse {
      0%, 100% { opacity: 0.18; filter: blur(0px); }
      50% { opacity: 0.75; filter: blur(0.4px); }
    }

    @keyframes avaNodePulse {
      0%, 100% { transform: scale(0.75); opacity: 0.35; }
      50% { transform: scale(1.18); opacity: 1; }
    }
  `;
    const games = [
        {
            name: "AVAAIO Checkers",
            icon: "⛀",
            desc: "Classic neon strategy battles.",
            path: "/games/checkers",
        },
        {
            name: "AVAAIO Chess",
            icon: "♛",
            desc: "Advanced tactical AI matches.",
            path: "/games/chess",
        },
    ];
    return (_jsxs("div", { style: {
            position: "relative",
            overflow: "hidden",
            minHeight: "100vh",
            textAlign: "center",
            color: themeColors.text,
            padding: "5rem 1rem 7rem",
            fontFamily: "Orbitron, sans-serif",
            background: "radial-gradient(circle at top, rgba(0,255,255,0.10), transparent 28%), linear-gradient(180deg, #02040a 0%, #030813 45%, #010205 100%)",
        }, children: [_jsx("style", { children: tronStyles }), _jsx("div", { style: {
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    background: "radial-gradient(circle at 50% 18%, rgba(0,255,255,0.18), transparent 26%), radial-gradient(circle at 15% 80%, rgba(0,120,255,0.12), transparent 22%), radial-gradient(circle at 85% 72%, rgba(120,0,255,0.10), transparent 24%)",
                } }), _jsx("div", { style: {
                    position: "absolute",
                    left: "-10%",
                    right: "-10%",
                    bottom: "-18%",
                    height: "58%",
                    pointerEvents: "none",
                    opacity: 0.42,
                    transform: "perspective(620px) rotateX(62deg)",
                    transformOrigin: "center bottom",
                    backgroundImage: `
            linear-gradient(rgba(0,255,255,0.22) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,150,255,0.18) 1px, transparent 1px)
          `,
                    backgroundSize: "54px 54px",
                    animation: "avaTronGridDrift 10s linear infinite",
                    boxShadow: "0 -18px 80px rgba(0,255,255,0.18)",
                } }), _jsx("div", { style: {
                    position: "absolute",
                    left: "7%",
                    right: "7%",
                    top: "47%",
                    height: "1px",
                    pointerEvents: "none",
                    background: "linear-gradient(90deg, transparent, rgba(0,255,255,0.85), rgba(0,120,255,0.55), transparent)",
                    boxShadow: "0 0 26px rgba(0,255,255,0.65)",
                    opacity: 0.72,
                } }), [...Array(7)].map((_, i) => (_jsx("div", { style: {
                    position: "absolute",
                    left: `${14 + i * 12}%`,
                    top: `${18 + (i % 3) * 8}%`,
                    width: "2px",
                    height: `${22 + (i % 2) * 18}%`,
                    borderRadius: 999,
                    pointerEvents: "none",
                    background: "linear-gradient(to bottom, transparent, rgba(0,255,255,0.7), transparent)",
                    boxShadow: "0 0 18px rgba(0,255,255,0.55)",
                    opacity: 0.24,
                    animation: `avaTronPulse ${2.4 + i * 0.35}s ease-in-out infinite`,
                } }, `trace-v-${i}`))), [...Array(6)].map((_, i) => (_jsx("div", { style: {
                    position: "absolute",
                    left: `${8 + i * 16}%`,
                    top: `${24 + i * 7}%`,
                    width: "180px",
                    height: "1px",
                    pointerEvents: "none",
                    transform: `rotate(${i % 2 === 0 ? 28 : -28}deg)`,
                    background: "linear-gradient(90deg, transparent, rgba(0,255,255,0.58), transparent)",
                    boxShadow: "0 0 16px rgba(0,255,255,0.48)",
                    opacity: 0.28,
                } }, `trace-d-${i}`))), [...Array(10)].map((_, i) => (_jsx("div", { style: {
                    position: "absolute",
                    left: `${10 + ((i * 17) % 80)}%`,
                    top: `${18 + ((i * 23) % 62)}%`,
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    pointerEvents: "none",
                    background: "rgba(0,255,255,0.95)",
                    boxShadow: "0 0 18px rgba(0,255,255,0.9)",
                    animation: `avaNodePulse ${2.2 + (i % 4) * 0.4}s ease-in-out infinite`,
                } }, `node-${i}`))), _jsx("div", { style: {
                    position: "absolute",
                    top: "16%",
                    left: "-22%",
                    width: "55%",
                    height: "18%",
                    pointerEvents: "none",
                    background: "linear-gradient(90deg, transparent, rgba(0,255,255,0.16), transparent)",
                    filter: "blur(14px)",
                    animation: "avaTronGlowSweep 7s ease-in-out infinite",
                } }), _jsxs("div", { style: { position: "relative", zIndex: 2 }, children: [_jsx("h1", { style: { color: themeColors.accent, marginBottom: 12 }, children: "\uD83C\uDFAE AVAAIO Games Hub" }), _jsx("p", { style: { marginBottom: 34, opacity: 0.86 }, children: "Choose a game to begin:" }), _jsx("div", { style: {
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                            gap: "22px",
                            width: "min(760px, 92vw)",
                            margin: "0 auto 46px",
                        }, children: games.map((g) => (_jsxs("button", { className: "console-btn", onClick: () => navigate(g.path), style: {
                                minHeight: 220,
                                borderRadius: 30,
                                padding: "24px 18px",
                                background: "linear-gradient(160deg, rgba(0,255,255,0.12), rgba(5,10,25,0.96))",
                                border: `1px solid ${themeColors.accent}`,
                                color: themeColors.text,
                                boxShadow: `0 0 34px ${themeColors.accent}22`,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 14,
                                width: "100%",
                                cursor: "pointer",
                                transition: "all 0.25s ease",
                            }, onMouseEnter: (e) => {
                                e.currentTarget.style.transform = "translateY(-4px) scale(1.02)";
                                e.currentTarget.style.boxShadow = `0 0 44px ${themeColors.accent}55`;
                            }, onMouseLeave: (e) => {
                                e.currentTarget.style.transform = "translateY(0px) scale(1)";
                                e.currentTarget.style.boxShadow = `0 0 34px ${themeColors.accent}22`;
                            }, children: [_jsx("div", { style: {
                                        fontSize: 72,
                                        lineHeight: 1,
                                        textShadow: "0 0 28px rgba(0,255,255,0.7)",
                                        filter: "drop-shadow(0 0 16px rgba(0,255,255,0.55))",
                                    }, children: g.icon }), _jsx("div", { style: {
                                        fontSize: 24,
                                        fontWeight: 800,
                                        letterSpacing: 1,
                                    }, children: g.name }), _jsx("div", { style: {
                                        fontSize: 13,
                                        opacity: 0.78,
                                        maxWidth: 220,
                                        lineHeight: 1.5,
                                    }, children: g.desc })] }, g.name))) })] })] }));
};
export default GamesHub;
